import { useState, type FormEvent } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { Dropdown } from "../../../../shadcn/components/custom/Dropdown";
import { ALL_BIDDER_TYPE_OPTIONS } from "services";

interface NIBidderTypeModalProps {
  onSubmit: (type: string) => Promise<void> | void;
  onCancel: () => void;
  redirectUrl?: string;
}

const NIBidderTypeModal = (props: NIBidderTypeModalProps) => {
  const [selectedType, setSelectedType] = useState<{
    value: string;
    label: string;
  }>({ value: "", label: "" });
  const [error, setError] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!selectedType?.value) {
      setError("Please select a non-individual type");
      return;
    }

    setIsSubmitting(true);

    try {
      if (props.onSubmit) {
        await props.onSubmit(selectedType?.value ?? "");
      }

      if (props.redirectUrl) {
        window.location.href = props.redirectUrl;
      }
    } catch (_error) {
      setError("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30 px-4">
      <div className="bg-white shadow-2xl rounded-xl w-full max-w-lg overflow-visible">
        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col items-center px-4 py-6 border bg-[#FCFFFB] border-brand-bgGrey rounded-lg"
        >
          <div className="flex items-center space-x-3">
            <div>
              <p className="font-openSans text-[22px] font-semibold text-brand-bgBlack text-center">
                Select Non-Individual Type
              </p>
            </div>
          </div>
          <div className={`relative w-full mt-5`}>
            <Dropdown
              dataSource={async () => {
                return ALL_BIDDER_TYPE_OPTIONS.filter(
                  (option) => option.value !== "individual",
                );
              }}
              defaultSelected={selectedType ? selectedType : {}}
              selectIdentifier={true}
              onChange={(value: any) => {
                setSelectedType(value);
                setError("");
              }}
              valueKey="value"
              placeholder="Choose the type of non-individual bidder"
              styles={{
                dropdownContentClass: "max-h-[320px] overflow-y-auto",
                dropdownItemsClass:
                  "bg-white text-brand-borderGrey whitespace-normal break-words leading-5 py-2 text-left",
                hoverBgColor: "focus:bg-brand-lightOrange",
                hoverTextColor: "focus:text-brand-borderGrey",
                hideDot: true,
                outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none  font-openSans font-normal text-web-body-sm  mid:text-web-body-md ${
                  selectedType?.value
                    ? "items-end text-brand-textLightGrey"
                    : "text-brand-borderGrey"
                } leading-5 `,
              }}
            />
          </div>
          {error ? (
            <p className="w-full mt-2 text-sm text-red-500">{error}</p>
          ) : null}

          <div className="w-full mt-6 flex space-x-4">
            <Button
              type="submit"
              className="w-1/2"
              disabled={isSubmitting || !selectedType?.value}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
            <Button
              type="button"
              variant="outline"
              className="w-1/2"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NIBidderTypeModal;
